import { type PageProps } from "gatsby";
import { type FC } from "react";
import { LoggedOutBar } from "../../components/AppBar/Bars";
import GuidepostSimplified from "../../components/Rozcestnik/GuidepostSimplified";
import { Seo } from "../../components/SEO";
import { withRedirectWhenLoggedIn } from "../../highOrderComponents/withRedirectWhenLoggedIn";
import { useClearCache } from "../../hooks/useClearCache";

export const AppBar: FC = () => <LoggedOutBar />;

const LoginPage: FC<PageProps> = (pageProps) => {
    useClearCache("/prihlaseni");

    return <GuidepostSimplified pageProps={pageProps} />;
};

export default withRedirectWhenLoggedIn(LoginPage);

export const Head: FC = () => <Seo title="Přihlášení" />;
